import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { SessionStore } from './session.store';

/**
 * Protege las rutas `/:id/main`. Exige que el indice de la URL corresponda a
 * una sesion guardada con token vigente; si no, manda al login de FrontKordata.
 */
export const authGuard: CanActivateFn = route => {
  const auth = inject(AuthService);
  const session = inject(SessionStore);

  const indice = Number(route.paramMap.get('id'));

  if (!Number.isInteger(indice) || indice < 0 || !auth.estaAutenticado(indice)) {
    auth.irALoginDeKordata();
    return false;
  }

  session.setIndice(indice);
  return true;
};
